import { useState } from 'react';
import { passwordResetRequestFields } from '../constants/formFields';
import Input from './Input';
import FormAction from './FormAction';

interface FormElements extends HTMLFormControlsCollection {
  emailAddress: HTMLInputElement;
}
interface ResetFormElement extends HTMLFormElement {
  readonly elements: FormElements;
}

const fields = passwordResetRequestFields;
const fieldsState: { [key: string]: string } = {};
fields.forEach((field) => (fieldsState[field.id] = ''));

export default function ResetRequest() {
  const [resetState, setResetState] = useState(fieldsState);
  const [formCompletedState, setFormCompletedState] = useState(false);

  const handleChange = (e: React.FormEvent<HTMLInputElement>) => {
    const btn = e.target as HTMLInputElement;
    setResetState({ ...resetState, [btn.id]: btn.value });
  };

  const handleSubmit = async (event: React.FormEvent<ResetFormElement>) => {
    // lets grab the redirect URL here
    const urlObj = new URL(window.location.href);

    event.preventDefault();
    await fetch('/api/users/reset/password', {
      method: 'POST',
      headers: {
        'content-type': 'application/x-www-form-urlencoded;charset=UTF-8',
        accept: 'application/json',
      },
      body: new URLSearchParams({
        email: event.currentTarget.elements.emailAddress.value,
        redirectUrl: urlObj.searchParams.get('redirectUrl') || '',
      }),
    });
    setFormCompletedState(true);
  };

  return (
    <form className="w-full" onSubmit={handleSubmit}>
      {formCompletedState && (
        <div
          className="bg-eirly-alt-100/10 border-t-4 border-eirly-alt-500 rounded-b text-teal-900 px-4 py-3 shadow-md"
          role="alert"
        >
          <div className="flex">
            <div className="py-1">
              <svg
                className="fill-current h-6 w-6 text-eirly-alt-500 mr-4"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
              >
                <path d="M2.93 17.07A10 10 0 1 1 17.07 2.93 10 10 0 0 1 2.93 17.07zm12.73-1.41A8 8 0 1 0 4.34 4.34a8 8 0 0 0 11.32 11.32zM9 11V9h2v6H9v-4zm0-6h2v2H9V5z" />
              </svg>
            </div>
            <div>
              <p className="font-bold">Success</p>
              <p className="text-sm">
                Password reset complete, please check your email address to
                complete the password reset
              </p>
            </div>
          </div>
        </div>
      )}
      <div className="-space-y-px">
        {fields.map((field) => (
          <Input
            key={field.id}
            handleChange={handleChange}
            value={resetState[field.id]}
            labelText={field.labelText}
            labelFor={field.labelFor}
            id={field.id}
            name={field.name}
            type={field.type}
            isRequired={field.isRequired}
            placeholder={field.placeholder}
          />
        ))}
      </div>
      <FormAction text="Reset" />
    </form>
  );
}
